import { SURVEY_BUILDER_POPUP_TYPES } from '../constants';
import {
  getNumberOfQuestionsToCharge,
  getSurveyQuestionsChargeAmount
} from '../getChargeAmount/getChargeAmount';
import getPermissionValue from '../getPermissionValue';

export default (
  isAdmin,
  survey,
  surveyLists,
  accountManagement,
  surveyPermissionsCharge,
  defaultPermissionValues
) => {
  const numberOfQuestionsToCharge = getNumberOfQuestionsToCharge(surveyLists);

  const questionsPerSurveyIncludedInLicence = getPermissionValue(
    survey,
    'questionsPerSurveyIncludedInLicence'
  );
  const surveyQuestionsChargeAmount = getSurveyQuestionsChargeAmount(
    numberOfQuestionsToCharge,
    questionsPerSurveyIncludedInLicence,
    defaultPermissionValues
  );

  const isChargeAmountIncreased =
    (surveyPermissionsCharge &&
      surveyPermissionsCharge.surveyQuestionsChargeAmount === null &&
      surveyQuestionsChargeAmount.total > 2.5) ||
    (surveyPermissionsCharge &&
      surveyPermissionsCharge.surveyQuestionsChargeAmount &&
      surveyQuestionsChargeAmount.total > 2.5 &&
      surveyQuestionsChargeAmount.total >
        surveyPermissionsCharge.surveyQuestionsChargeAmount.total);

  if (survey) {
    const isThereAnyLicence =
      (survey.recordDetails && survey.recordDetails.haveCreditsLeft) ||
      (survey.recordDetails &&
        survey.recordDetails.parent &&
        survey.recordDetails.parent.haveCreditsLeft);

    if (!survey.paid) {
      if (
        !isThereAnyLicence &&
        !surveyPermissionsCharge.noLicenceMoreThan15WarningShown &&
        numberOfQuestionsToCharge > 15
      ) {
        return {
          accountManagementQuestionsWarning:
            SURVEY_BUILDER_POPUP_TYPES.NO_LICENCE_MORE_THAN_15,
          surveyQuestionsChargeAmount
        };
      }

      if (
        isChargeAmountIncreased &&
        isThereAnyLicence &&
        numberOfQuestionsToCharge > 15
      ) {
        return {
          accountManagementQuestionsWarning:
            SURVEY_BUILDER_POPUP_TYPES.EXTRA_QUESTIONS_ABOVE_LICENCE_ADDED,
          surveyQuestionsChargeAmount
        };
      }
    }

    if (
      survey.paid &&
      !surveyPermissionsCharge.unpublishedWarningShown &&
      isThereAnyLicence
    ) {
      return {
        accountManagementQuestionsWarning:
          SURVEY_BUILDER_POPUP_TYPES.SURVEY_UNPUBLISHED_QUESTIONS_ADDED,
        surveyQuestionsChargeAmount
      };
    }
  }

  return {
    accountManagementQuestionsWarning: null,
    surveyQuestionsChargeAmount
  };
};
